import { createBrowserRouter } from 'react-router'

import Layout from './components/Layout/Layout'
import Index from './pages/Index'
import AboutPage from './pages/AboutPage/about_page'
import ListingsPage from './pages/Listings/listings_page'
import Notfound from './pages/Notfound'
import ProjectsPage from '@/pages/Projects/projects_page'
import TeamPage from '@/pages/TeamPage/team_page'
import BlogsPage from '@/pages/BlogsPage/blogs_page'
import { Post } from './components/Blogs/Post'
import ImageGallery from './components/Gallery/Gallery'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Layout>
        <Index />
      </Layout>
    ),
  },
  {
    path: '/about',
    element: (
      <Layout>
        <AboutPage />
      </Layout>
    ),
  },
  {
    path: '/listings',
    element: (
      <Layout>
        <ListingsPage />
      </Layout>
    ),
  },
  {
    path: '/projects',
    element: (
      <Layout>
        <ProjectsPage />
      </Layout>
    ),
  },
  // {
  //   path: '/team',
  //   element: (
  //     <Layout>
  //       <TeamPage />
  //     </Layout>
  //   ),
  // },
  {
    path: '/blogs',
    element: (
      <Layout>
        <BlogsPage />
      </Layout>
    ),
  },
  {
    path: '/gallery',
    element: (
      <Layout>
        <ImageGallery />
      </Layout>
    ),
  },
  {
    path: '/blogs/:blogId',
    element: (
      <Layout>
        <Post />
      </Layout>
    ),
  },
  {
    path: '*',
    element: (
      <Layout>
        <Notfound />
      </Layout>
    ),
  },
])

export default router
